/// <reference path="../../Common/Base/SiteEntityDialog.ts" />

namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    @Serenity.Decorators.panel()
    export class SecurityRelationshipDialog extends SiteEntityDialog<SecurityRelationshipRow, any> {
        protected getFormKey() { return SecurityRelationshipForm.formKey; }
        protected getIdProperty() { return SecurityRelationshipRow.idProperty; }
        protected getLocalTextPrefix() { return SecurityRelationshipRow.localTextPrefix; }
        protected getService() { return SecurityRelationshipService.baseUrl; }

        protected form = new SecurityRelationshipForm(this.idPrefix);
    }
}